import { render, staticRenderFns } from "./mdc-tab.vue?vue&type=template&id=456301b8&scoped=true&"
import script from "./mdc-tab.vue?vue&type=script&lang=ts&"
export * from "./mdc-tab.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-tab.vue?vue&type=style&index=0&id=456301b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456301b8",
  null
  
)

export default component.exports